import api from '../../../utils/api';
import { ListingsPath } from '../listings/enums';
import { SoldDataPathType } from './enums';

export default class SoldDataApiService {
  static sendShareEmail(params) {
    return api.post(
      `${ListingsPath.Root}${SoldDataPathType.SendShareSoldDataEmail}`,
      params,
    );
  }
}
